import React, { useEffect, useRef, useState } from 'react';
import useTranslations from '../../../utils/useTranslations';
import backgrounds from '../../../components/backgrounds';
import Logo from '../../../components/logo';
import { getBaiAdStyle } from '../../../utils/baiAd';
import { NEO_DOWNLOAD_URL } from '../../../constants/bittorrentNeo';
import Seo from '../../../components/seo';

const neoInstaller = 'BitTorrentNeo.dmg';
const heightParentHeightRatio = 0.45;

const DownloadsCompleteNeo = ({ pageContext: { text, locale } }) => {
    const t = useTranslations(text);
    const [fs, setFs] = useState(16);
    const innerContainerRef = useRef();
    const baiStyle = getBaiAdStyle(locale, '1500x300', '1500/300', {
        width: '100%',
        display: 'block',
    });

    const adjustFs = (prevFs) => {
        if (!innerContainerRef.current) {
            return;
        }

        const height = innerContainerRef.current.clientHeight;
        const parentHeight = innerContainerRef.current.offsetParent.clientHeight;
        const nextFs = prevFs - 0.5;
        if (nextFs <= 12) {
            return;
        }
        if (height / parentHeight > heightParentHeightRatio) {
            setFs(nextFs);
        }
    };

    useEffect(() => {
        adjustFs(fs);
    }, [fs]);

    useEffect(() => {
        const downloadTimer = setTimeout(() => {
            window.location = NEO_DOWNLOAD_URL;
        }, 1);

        return () => clearTimeout(downloadTimer);
    }, []);

    const runInstaller = t('Run $brandInstaller to install', {
        brandInstaller: <span className="tw-text-link2">{neoInstaller}</span>,
    });

    const tryAgain = (
        <p className="text-danger font-weight-bold ml-3" style={{ ...font.md }}>
            *{' '}
            {t('if you have trouble downloading or installing, try this version.', {
                version: (
                    <a href={NEO_DOWNLOAD_URL} className="tw-text-link2">
                        {t('version')}
                    </a>
                ),
            })}
        </p>
    );

    const macInstallHelp = (
        <p className="text-white ml-3" style={{ ...font.md }}>
            *{' '}
            {t('Having trouble installing on Mac? Find the solution here.', {
                here: (
                    <a
                        href="/en/support/solutions/articles/29000034450--will-damage-your-computer-you-should-move-it-to-the-trash-"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="tw-text-link2"
                    >
                        {t('here')}
                    </a>
                ),
            })}
        </p>
    );

    return (
        <div
            className="download-complete-container top-section-container d-flex align-items-center flex-column
                overflow-auto background-noise-dark"
            style={backgrounds.darkBg}
        >
            <div
                className="container pt-0 px-5 mb-5 download-complete-inner-container"
                ref={innerContainerRef}
                style={{ fontSize: `${fs}px` }}
            >
                <p
                    className="text-white p-absolute text-center font-weight-bold"
                    style={{ fontSize: `${fs * 2}px`, ...style.headerSpacing }}
                >
                    {t('Thank you for downloading')}
                </p>
                <div className="row">
                    <div className="col-lg-5 d-flex flex-column align-items-center align-items-lg-end justify-content-center">
                        <div
                            className="d-flex align-items-center justify-content-center px-3"
                            style={style.logoPanel}
                        >
                            <Logo
                                color="white-bt"
                                tag="p"
                                productName="Neo"
                                className="pdlp-logo text-nowrap text-left text-lg-right mb-0"
                                fsMax={26}
                                fsCoefficient={15}
                                fixedParentDistance={2}
                            />
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <ul className="text-white m-0 download-complete-list" style={font.lg}>
                            <li className="my-3">{t('Wait for the download to finish*')}</li>
                            <li className="my-3">{t('Exit $brand Neo if application is running')}</li>
                            <li className="my-3">{runInstaller}</li>
                            <li className="my-3">{t('$brand Neo will run once installed')}</li>
                        </ul>
                        {tryAgain}
                        {macInstallHelp}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-12">
                        <a
                            id="downloads-complete-neo-bai-ad"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://chat.b.ai/chat?utm_source=bt"
                            style={baiStyle}
                        ></a>
                    </div>
                </div>
            </div>
            <div className="download-complete-bottom-container w-100 d-flex" />
        </div>
    );
};

export default DownloadsCompleteNeo;

const font = {
    lg: {
        fontSize: '1.6em',
    },
    md: {
        fontSize: '1.25em',
    },
};

const style = {
    headerSpacing: {
        padding: '1em 0',
        margin: '1em 0',
    },
    logoPanel: {
        // backgroundColor: '#3a3b42',
        minHeight: '80px',
        maxWidth: '404px',
        width: '100%',
    },
};

export const Head = ({ pageContext }) => <Seo pageContext={pageContext} />;
